import { Link } from 'react-router-dom';

import { FOCO_VISIVEL } from 'utils/foco';

const CLASSE_DO_VOLTAR = `flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-0 bg-brand-blue p-0 ${FOCO_VISIVEL}`;

const SETA_DO_VOLTAR = (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--brand-yellow)" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
    <path d="m15 18-6-6 6-6" />
  </svg>
);

interface CabecalhoDaMinhaEquipeProps {
  faseAtual: string | null;
  /** Na equipe lateral, a seta volta à própria equipe (MEQ2-05); sem isto, à página inicial. */
  onVoltarParaMinhaEquipe?: () => void;
}

/** Topo das páginas da Minha Equipe: voltar, título e a fase atual do ciclo. */
export default function CabecalhoDaMinhaEquipe({ faseAtual, onVoltarParaMinhaEquipe }: CabecalhoDaMinhaEquipeProps) {
  return (
    <div className="mb-[22px] flex flex-wrap items-center gap-3.5">
      {onVoltarParaMinhaEquipe ? (
        <button type="button" onClick={onVoltarParaMinhaEquipe} aria-label="Voltar para minha equipe" className={CLASSE_DO_VOLTAR}>
          {SETA_DO_VOLTAR}
        </button>
      ) : (
        <Link to="/" aria-label="Voltar para a página inicial" className={CLASSE_DO_VOLTAR}>
          {SETA_DO_VOLTAR}
        </Link>
      )}
      <h1 className="m-0 font-display text-jj-h1 font-extrabold text-brand-blue-dark">Minha Equipe</h1>
      {faseAtual && (
        // SPEC_DEVIATION: fundo `brand-blue-dark` (design `brand-blue`, 4,44:1 com o texto amarelo de 12px, EQP-33).
        // `text-xs` e não `text-jj-caption`: mantém a altura de linha de 16px que a pílula já tinha.
        <span className="ml-auto rounded-jj-pill bg-brand-blue-dark px-4 py-2 font-display text-xs font-bold text-brand-yellow">
          Fase atual · {faseAtual}
        </span>
      )}
    </div>
  );
}
